module.exports = __webpack_public_path__ + "d9be83c54de3a8c408af18a649caedac.svg";